import { newModalFromString } from './components/modal';
// tabs for style guide page
document.addEventListener('DOMContentLoaded', () => {
    GetColourMenuItemProduct();
    AddMobileGuideMenuItem();

    $('ul.tabs-style-guide li').click(function () {
        var tabId = $(this).attr('data-tab');

        $('ul.tabs-style-guide li').removeClass('current');
        $('.tab-content-style-guide').removeClass('current');

        $(this).addClass('current');
        $('#' + tabId).addClass('current');
        $('.slick-slider.slick-initialized').slick('refresh');
    });
    // tabs for textiles guide page
    $('ul.tabs-textiles-guide li').click(function () {
        var tabId = $(this).attr('data-tab');

        $('ul.tabs-textiles-guide li').removeClass('current');
        $('.tab-content-textiles-guide').removeClass('current');

        $(this).addClass('current');
        $('#' + tabId).addClass('current');
        $('.slick-slider.slick-initialized').slick('refresh');
    });

    // tabs style guide categories
    $('ul.tabs-style-guide li').on('click', function (e) {
        e.preventDefault();

        if (!Foundation.MediaQuery.atLeast('medium')) {
            var tabId = $(this).attr('data-tab');
            var tabContent = $('#' + tabId).html();

            const htmlContent = $('.js-modal-product-guide').html();
            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false);
            modal.open();
            modal.setContent(tabContent);
            swapElements();
            $('.tingle-modal').addClass('wrapperModal');
            $('.tingle-modal-box').addClass('cc-modalStyleGuide');
            $('.tingle-modal-box__content').addClass('modal-tabs-style');
            $(modal.modalBox)
                .find('.close')
                .on('click', function (e) {
                    modal.close();
                });

            $('.js-inside-close-modal').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });

            $('[data-dismiss="modal"]').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });
        }
    });

    $('ul.tabs-textiles-guide li').on('click', function (e) {
        e.preventDefault();

        if (!Foundation.MediaQuery.atLeast('medium')) {
            var tabId = $(this).attr('data-tab');
            var tabContent = $('#' + tabId).html();

            const htmlContent = $('.js-modal-product-guide').html();
            // create and open confirmation modal
            const modal = newModalFromString(htmlContent, false);
            modal.open();
            modal.setContent(tabContent);
            swapElements();
            $('.tingle-modal').addClass('wrapperModal');
            $('.tingle-modal-box').addClass('cc-modalTextileGuide');
            $('.tingle-modal-box__content').addClass('modal-tabs-textiles');
            $(modal.modalBox)
                .find('.close')
                .on('click', function (e) {
                    modal.close();
                });

            $('.js-inside-close-modal').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });

            $('[data-dismiss="modal"]').on('click', function (e) {
                e.preventDefault();
                modal.close();
            });
        }
    });

    function GetColourMenuItemProduct () {
        const $selectedCustomerPage = $('.js-recognize-page-productguide');
        if ($selectedCustomerPage.hasClass('js-productguide-size-page')) {
            $('.product-guide-menu  li.size-item').addClass('background-active-item');
        } else if ($selectedCustomerPage.hasClass('js-productguide-style-page')) {
            $('.product-guide-menu  li.style-item').addClass('background-active-item');
        } else if ($selectedCustomerPage.hasClass('js-productguide-textiles-page')) {
            $('.product-guide-menu  li.textiles-item').addClass('background-active-item');
        } else if ($selectedCustomerPage.hasClass('js-productguide-care-page')) {
            $('.product-guide-menu  li.care-item').addClass('background-active-item');
        }
    }

    function AddMobileGuideMenuItem () {
        const $mobileItemBox = $('.mobile-only-product-guide-item');
        const itemCode = $('.js-productguide-mobile-page').html();
        $mobileItemBox.html(itemCode);
        $mobileItemBox.removeClass('hide');
    }

    // Swap title and image inside the modal of the style guide and textiles content asset
    function swapElements () {
        const title = document.querySelector('.tab-title');
        const image = document.querySelector('.img-modal-mobile');
        const temp = document.createElement('div');
        title.parentNode.insertBefore(temp, title);
        image.parentNode.insertBefore(title, image);
        temp.parentNode.insertBefore(image, temp);
        temp.parentNode.removeChild(temp);
    }
});
